import React, { useContext, useEffect } from "react";
import Style from "./home.module.scss";
import {
  StudentSideMenu,
  StudentNotification,
  StudentCourse,
  DashBar,
  EventInfo,
} from "../../../layout/Dashboard";

import { Brightness4, LightMode } from "@mui/icons-material";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import { styled } from "@mui/material/styles";

import { Link, useLocation, useHistory } from "react-router-dom";
import { ThemeContext } from "../../../context/theme/ThemeContext";

import { AuthContext } from "../../../context/auth/ApiContext";
import { authGetRequest } from "../../../api/laravel/public/api";
import ModalLayout from "../../../components/Modal/Modal";
import { ProfileUpdateNotification } from "../../../layout/Notifications";
import { errorMessage } from "../../../utils/notification";
import { toast } from "react-toastify";
import { settingContext } from "../../../context/Setting/Setting";
import { Company, Footer, MenuBar } from "../../../layout/welcome";
import { _retrieveData, _storeData } from "../../../utils/local-storage";
import Rightbar from "../../../layout/Dashboard/student/rightbar/Rightbar";
import { HeaderText } from "../../../components";



const Home = () => {
  const { theme, changeTheme } = useContext(ThemeContext);
  const { page, loading } = React.useContext(settingContext);
  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor: "white",
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: theme.palette.mode === "light" ? "#545be8" : "#545be8",
    },
  }));
  // const { membership } = React.useContext(MembershipContext);
  const history = useHistory();
  const [data, setData] = React.useState({});
  const [event, setEvent] = React.useState({});
  const [inbox, setInbox] = React.useState({});
  const [isPageLoader, setPageLoader] = React.useState(true);
  const [ user, setUser ] = React.useState({});



  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  React.useEffect(() => {
    checkUser();
    // dashboardGet();
  }, []);

  // React.useEffect((e) => {
  //   eventsGet();
  //   getInbox();
  // }, []);



  const checkUser = async () => {
    setPageLoader(true);
    let storeUser = await _retrieveData('user_info');
    if (storeUser) {
      setUser(storeUser);
    }
    const { data_r, isLoading, isError } = await authGetRequest("/account/profile");
    setPageLoader(false);
    if (isError) {
      history.push("/auth/login");
    }
    else {
      await _storeData(data_r, 'user_info');
      setUser(data_r);
      dashboardGet();
    }
  }


  const dashboardGet = async () => {
    setPageLoader(true);
    const { data_r, isError } = await authGetRequest(`/account/dashboard`);
    if (isError) {
      // errorMessage(toast, data_r?.message);
      setPageLoader(false);
      return false;
    }
    setData(data_r);
    setPageLoader(false);
  };

  return (
    <div id="page-top" class="home">
      <div id="page-wrap">
        <MenuBar event={event} inbox={inbox} menuIndex="auth" setting={page?.setting} loader={isPageLoader} />
        <section className="profile-feature">
          <div className="awe-parallax bg-profile-feature" style={{ backgroundImage: 'url(../img/bg.jpg)' }} />
          <div className="awe-overlay overlay-color-3" />
          <div className="container">
            <div className="info-author">
              <div className="image">
                <img src={user?.image ? process.env.REACT_APP_LOCAL_FILE_PATH + "profile/medium/" + user.image : user?.gender === "male" ? '/static/media/male.png' : '/static/media/female.png'} alt="" />
              </div>
              <div className="name-author">
                <h2 className="big">{user?.first_name} {user?.last_name}</h2>
              </div>
              <div className="address-author">
                <i className="fa fa-map-marker" />
                <h3>{user?.country}</h3>
              </div>
            </div>
            <div className="info-follow">
              <div className="trophies">
                <span>{data?.cert_count}</span>
                <p>Certificates</p>
              </div>
              <div className="trophies">
                <span>{data?.count_course}</span>
                <p>Courses</p>
              </div>
              <div className="trophies">
                <span>{data?.count_active_course}</span>
                <p>Active Course</p>
              </div>
              <div className="trophies">
                <span>{data?.complete_course}</span>
                <p>Completed Course</p>
              </div>
            </div>
          </div>
        </section>

        <section className="content-bar">
          <div className="container">
            <ul style={{ width: '100%' }}>
              <li className="current">
                <Link to="/student/home">
                  <i className="icon mdi mdi-book-open" />
                  Learning
                </Link>
              </li>
              <li>
                <Link to="/student/courses">
                  <i className="icon mdi mdi-note" />
                  Courses
                </Link>
              </li>
              <li>
                <Link to="/student/calendar">
                  <i className="icon mdi mdi-calendar" />
                  Events
                </Link>
              </li>
              {/* <li>
                <a href="account-assignment.html">
                  <i className="icon mdi mdi-note" />
                  Assignment
                </a>
              </li> */}
              <li>
                <Link to="/student/profile">
                  <i className="icon mdi mdi-account" />
                  Profile
                </Link>
              </li>
              <li>
                <Link to="/student/inbox">
                  <i className="icon mdi mdi-gmail" />
                  Inbox
                </Link>
              </li>
            </ul>
          </div>
        </section>

        <section id="course-concern" className="course-concern">
          <div className="container mt-4">
            <HeaderText text={"Active Course"} />
            <div className="row">
              {data?.total_course?.map((item, index) => {
                if (index < 3)
                  return (
                    <StudentCourse
                      item={item.course}
                      list={3}
                      link={
                        item?.course ? "/student/course/" + item.course?.uuid : ""
                      }
                      progress={item.progress}
                      key={index}
                    />
                  )
              })}
            </div>
          </div>
          <div className="container mb-4">
            <HeaderText text={"Register New Course"} />
            <div className="row">
              {data?.related_course?.map((item, index) => {
                if (
                  index < 3 &&
                  data?.total_course.findIndex((it) => it.course_id != item.id)
                )
                  return (
                    <StudentCourse
                      item={item}
                      list={3}
                      link={item ? "/course/" + item?.uuid : ""}
                      progress={null}
                      key={index}
                    />
                  )
              })}
            </div>
          </div>
          <div className="container mb-4">
            <HeaderText text={"Pending Course"} />
            <div className="row">
              {data?.pend_course?.map((item, index) => {
                if (
                  index < 3 &&
                  data?.total_course.findIndex((it) => it.course_id != item.id)
                )
                  return (
                    <StudentCourse
                      item={item.course}
                      list={3}
                      link={item ? "/course/" + item.course?.uuid : ""}
                      progress={null}
                      key={index}
                    />
                  )
              })}
            </div>
          </div>

        </section>

        <Footer setting={page?.setting} />
      </div>
      {/* <StudentNotification user={user} /> */}
      <ModalLayout
        padding={0}
        modal={!user?.first_name ? true : false}
        content={<ProfileUpdateNotification />}
      />
    </div>

  );
};

export default Home;
